module.exports = __webpack_public_path__ + "static/media/beep.21a0a9c1.mp3";